import ArticleNode from './articleNode';

export default ArticleNode;
